import { useGetBusiness } from "@/business/query";
import { useBusiness } from "@/core/business";
import type { ProfitabilityAccess } from "./types";

/**
 * Whether the person may manage a template: run it, mark its periods
 * reviewed, choose a period's result, edit it and share it. Mirrors the API's
 * `Profitability::Access`; a manager an owner shared the template with has
 * "view" and only reads it and works its findings.
 */
export const canManageReport = (
  report: { access: ProfitabilityAccess } | null | undefined,
) => report?.access === "manage";

/**
 * The same answer for the selected business, for controls that have no
 * template in hand (a period's review, a run's page). The API's access is the
 * same for every template a person can open: finance manages them all, and a
 * manager views the ones shared with them.
 */
export const useCanManageProfitability = () => {
  const { businessId } = useBusiness();
  const { data } = useGetBusiness(businessId);
  return data?.profitability_access !== "view";
};

/** Why there is no New template, as the API's refusal says it. */
export const TEMPLATES_BY_VOLCA =
  "Agents are set up by Volca while ServiceTitan reporting is on.";

/** Whether owners write their own templates (`profitability_templates_by_owner`). */
export const ownersWriteTemplates = (
  business: { profitability_templates_by_owner: boolean } | null | undefined,
) => business?.profitability_templates_by_owner === true;
